import React from 'react';
import { format, parseISO, addDays } from 'date-fns';
import { it } from 'date-fns/locale';
import styles from './MenuViewer.module.css';

function weekLabel(weekStart) {
  const start = parseISO(weekStart);
  const end = addDays(start, 6);
  return `Settimana dal ${format(start, 'd MMMM', { locale: it })} al ${format(end, 'd MMMM yyyy', { locale: it })}`;
}

export default function MenuViewer({ menu, onDelete }) {
  const fileUrl = `/uploads/${menu.filename}`;

  return (
    <div className={styles.wrapper}>
      <div className={styles.toolbar}>
        <div>
          <h1 className={styles.title}>{weekLabel(menu.weekStart)}</h1>
          <p className={styles.meta}>
            Caricato il {format(parseISO(menu.uploadedAt), "d MMMM yyyy 'alle' HH:mm", { locale: it })}
            {menu.note && <> · {menu.note}</>}
          </p>
        </div>
        <div className={styles.actions}>
          <a className={styles.btnSecondary} href={fileUrl} target="_blank" rel="noopener noreferrer">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
              <polyline points="15 3 21 3 21 9" />
              <line x1="10" y1="14" x2="21" y2="3" />
            </svg>
            Apri in nuovo tab
          </a>
          <button className={styles.btnDanger} onClick={() => onDelete(menu.id)}>
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="3 6 5 6 21 6" />
              <path d="M19 6l-1 14H6L5 6" />
              <path d="M10 11v6M14 11v6" />
              <path d="M9 6V4h6v2" />
            </svg>
            Elimina
          </button>
        </div>
      </div>
      <div className={styles.viewerFrame}>
        <iframe

          src={fileUrl}
          title={weekLabel(menu.weekStart)}
          className={styles.iframe}
          sandbox="allow-same-origin allow-popups allow-scripts"
        />
      </div>
    </div>
  );
}
